// extracted by mini-css-extract-plugin
export default {"message":"DeleteConfirmModal_message__4MMq+","footer":"DeleteConfirmModal_footer__3M7sq","deleteBtn":"DeleteConfirmModal_deleteBtn__nlF9D"};